import { render, staticRenderFns } from "./TranslateDialog.vue?vue&type=template&id=049eb2e2&"
import script from "./TranslateDialog.vue?vue&type=script&lang=js&"
export * from "./TranslateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports